export default {
  showChangelog: 'Pokaż wszystkie notatki o wydaniu',
};
